import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const NO_ACCOUNT = "__none";

export function useCashAccounts() {
  return useQuery({ queryKey: ["wallet-cash-accounts"], queryFn: async () => (await api.get("/wallet/cash-accounts")).data });
}

export default function CashAccountSelect({ value, onChange, testId }) {
  const { data: accounts = [] } = useCashAccounts();
  return (
    <Select value={value || NO_ACCOUNT} onValueChange={(v) => onChange(v === NO_ACCOUNT ? "" : v)}>
      <SelectTrigger className="mt-1.5" data-testid={testId}><SelectValue placeholder="Cassa"/></SelectTrigger>
      <SelectContent>
        <SelectItem value={NO_ACCOUNT}>Non registrare in cassa</SelectItem>
        {accounts.map((a) => <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
